export default __webpack_public_path__ + "static/media/portfolio3.a6c756d0.jpg";